import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL
const BASE_URL_FILE = process.env.REACT_APP_FILE_BASE_URL

export default function Header() {

  const [apiError, setApiError] = useState("");
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear()
    navigate('/')
  }

  const role = localStorage.getItem('role')
  const isAdmin = role == 'admin'

  useEffect(() => {
    let token = localStorage.getItem("token")
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${BASE_URL}get-profile`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        setUserData(response.data.data)

      } catch (error) {
        setApiError("Failed to load profile.");
      }
    };

    if (token) {
      fetchProfile();
    }
  }, []);

  return (
    <div className="main-header login-head">
      <Container>
        <div className="header-content">
          <img
            src={require("../images/main-logo.png")}
            onClick={() => navigate("/home")}
          />
          {userData && <ul>
            {isAdmin ?
              <>
                <li>
                  <Link to="/all-users">All User</Link>
                </li>
                <li>
                  <Link to="/all-requests">All Requests</Link>
                </li>
              </>
              :
              <li>
                <Link to="/engineers-forms">History</Link>
              </li>
            }
            <li>
              <div className="user-profile">
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <img src={require("../images//author-gravatar.webp")} />
                    {isAdmin ? 'Super Admin' : `${userData?.name}`}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {!isAdmin && <Dropdown.Item href="/change-password" className="mt-2">
                      Change Password
                    </Dropdown.Item>}
                    <Dropdown.Divider />
                    <Dropdown.Item href="/">
                      <div className="log-out-pro" onClick={handleLogout}>
                        Logout
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                        >
                          <path
                            d="M3.41683 12.8333C3.26212 12.8333 3.11375 12.7719 3.00435 12.6625C2.89495 12.5531 2.8335 12.4047 2.8335 12.25V1.74999C2.8335 1.59528 2.89495 1.44691 3.00435 1.33751C3.11375 1.22811 3.26212 1.16666 3.41683 1.16666H11.5835C11.7382 1.16666 11.8866 1.22811 11.996 1.33751C12.1054 1.44691 12.1668 1.59528 12.1668 1.74999V3.49999H11.0002V2.33332H4.00016V11.6667H11.0002V10.5H12.1668V12.25C12.1668 12.4047 12.1054 12.5531 11.996 12.6625C11.8866 12.7719 11.7382 12.8333 11.5835 12.8333H3.41683ZM11.0002 9.33332V7.58332H6.91683V6.41666H11.0002V4.66666L13.9168 6.99999L11.0002 9.33332Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </li>
          </ul>}
        </div>
      </Container>
    </div>
  );
}
